<template>
  <div class="vip">
    <div class="detail">
      <img class="detail-bg" :src="userInfo.personal_vip_bg" alt="">
      <div class="vip-status">
        <div class="title">{{userInfo.vip_title}}</div>
        <div class="sub-title">{{userInfo.vip_end_date}}</div>
        <button class="buy" @click="jumpVip">{{userInfo.vip_type ? '立即续费' : '立即开通会员'}}</button>
      </div>
      <div class="number-container">
        <div class="top">
          <div class="left">
            我的可用配音<span class="number" :class="{'highlight': remainingAvailable.total}">{{remainingAvailable.total}}</span><span class="unit">条</span>
          </div>
          <div class="right" @click="showBagDialog">
            <SuperAudioBag></SuperAudioBag>
          </div>
        </div>
        <div class="bottom">
          <div class="item">
            <div class="item-left">
              <div>会员权益</div>
              <div class="date">剩余{{remainingAvailable.vipDays}}天</div>
            </div>
            <div class="item-right"><span class="number" :class="{'highlight-vip': remainingAvailable.vipNumber}">{{remainingAvailable.vipNumber}} </span><span class="unit"> 条</span></div>
          </div>
          <div class="line"></div>
          <div class="item">
            <div class="item-left">
              <div>配音包</div>
              <div class="date">最近过期包剩余{{remainingAvailable.packageDays}}天</div>
            </div>
            <div class="item-right"><span class="number" :class="{'highlight-package': remainingAvailable.packageNumber}">{{remainingAvailable.packageNumber}} </span><span class="unit"> 条</span></div>
          </div>
          <div class="line"></div>
          <div class="item">
            <div class="item-left">
              <div>赠送/兑换</div>
              <div class="date">永久有效</div>
            </div>
            <div class="item-right"><span class="number" :class="{'highlight-free': remainingAvailable.freeNumber}">{{remainingAvailable.freeNumber}} </span><span class="unit"> 条</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="table">
        <div class="table-header">
          <span
            class="header-item"
            :style="{ width: tableWidth[index] ? tableWidth[index] + 'px' : 'auto', flex: tableWidth[index] ? '' : 1}"
            v-for="(item, index) in headerList"
            :key="index"
            >{{ item }}</span
          >
        </div>
        <div class="table-list" v-show="list.length">
          <div class="table-tr" v-for="item,index in list" :key="index">
            <div class="table-th" :style="{ flex: 1}">
              {{item.order_name}}
            </div>
            <div class="table-th" :style="{ width: tableWidth[1] + 'px'}">
              {{item.date}}
            </div>
            <div class="table-th" :style="{ width: tableWidth[2] + 'px'}">
              {{item.num_dubbings}}条
            </div>
          </div>
        </div>
        <NoData tips="暂无操作记录" v-show="!list.length"></NoData>
      </div>
      <footer v-show="list.length">
        <Pagination @jump="getList" :customPageSize="5" :total="total" :resetPage="resetPage"></Pagination>
      </footer>
    </div>
    <SuperAudioBagDialog v-if="showBagFlag"></SuperAudioBagDialog>
  </div> 
</template>

<script>
import SuperAudioBag from 'components/super-audio-bag.vue'
import SuperAudioBagDialog from 'components/super-audio-bag-dialog.vue'
import Pagination from 'components/pagination.vue'
import { topupOrConsumeDetailsList } from '@/api/users.js'
import {
  remainingAvailableDubbings
} from 'api/users.js'
import { formatUnixTime } from '@/utils/timeformat.js'
import NoData from 'components/no-data.vue'

export default {
  name: 'PersonalVip',
  props: {
    msg: String
  },
  components: {
    SuperAudioBag,
    SuperAudioBagDialog,
    Pagination,
    NoData
  },
  data () {
    return {
      vipImage: '',
      remainingAvailable: {},
      tableWidth: ['', 200, 100],
      headerList: [
        "操作记录",
        "时间",
        "数量/条",
      ],
      list: [],
      total: 0,
      resetPage: false,
    }
  },
  computed: {
    showBagFlag () {
      return this.$store.state.global.showBagFlag
    },
    userInfo () {
      return this.$store.state.global.userInfo
    },
    bagPaid () {
      return this.$store.state.global.bagPaid
    }
  },
  watch: {
    bagPaid (val) {
      if (val) {
        this.resetPage = true
        this.remainingAvailableDubbings()
        this.$store.dispatch('global/setBagPaid', false)
      }
    }
  },
  created () {
    this.remainingAvailableDubbings()
  },
  mounted() {
  },
  methods: {
    showBagDialog() {
      this.$store.dispatch('global/setBagFlag', true)
    },
    closeBagDialog () {
      this.$store.dispatch('global/setBagFlag', false)
    },
    async getList (page) {
      this.resetPage = false
      const res = await topupOrConsumeDetailsList(page)
      if (res.code !== 0) {
        return
      }
      const {list, total} = res.data
      this.list = list.map((ele)=>{
        ele.date = formatUnixTime(ele.update_time)
        return ele
      })
      this.total = total
    },
    jumpVip () {
      this.$router.push('/vip')
    }, 
    async remainingAvailableDubbings() {
      const res = await remainingAvailableDubbings()
      if (res.code !== 0) {
        return
      }
      const { dubbing_package_rest_days, dubbing_package_rest_dubbings, common_free_dubbings, vip_rest_days, vip_mouthly_rest_dubbings } = res.data
      this.remainingAvailable = {
        total: common_free_dubbings + vip_mouthly_rest_dubbings + dubbing_package_rest_dubbings,
        freeNumber: common_free_dubbings,
        vipNumber: vip_mouthly_rest_dubbings,
        vipDays: vip_rest_days,
        packageNumber: dubbing_package_rest_dubbings,
        packageDays: dubbing_package_rest_days
      }
    }
  },
  beforeDestroy(){
    this.$store.dispatch('global/setBagFlag', false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vip {
  height: 100%;
  padding-bottom: 20px;
  .detail {
    background-color: #fff;
    padding: 40px;
    border-radius: 4px;
    display: flex;
    position: relative;
    .detail-bg {
      position: absolute;
    }
    .vip-status {
      width: 360px;
      height: 180px;
      padding-left: 28px;
      box-sizing: border-box;
      position: relative;
      // background: url('../../assets/images/personal/vip_0.png') center no-repeat;
      .title {
        font-size: 24px;
        color: #666666;
        padding: 39px 0 26px;
        line-height: 24px;
      }
      .sub-title {
        font-size: 14px;
        // color: #999999;
        margin-bottom: 15px;
      }
      .buy {
        background: #FFE190;
        border: 1px solid #A6682C;
        border-radius: 18px;
        font-size: 14px;
        color: #A6682C;
        text-align: center;
        width: 116px;
        height: 36px;
        line-height: 1;
      }
    }
    .number-container {
      margin-left: 45px;
      padding-top: 10px;
      min-width: 500px;
      flex: 1;
      .unit {
        font-size: 14px;
        font-style: normal;
        color: #999999;
      }
      .top {
        display: flex;
        border-bottom: solid 1px #D8D8D8;
        padding-bottom: 35px;
        justify-content: space-between;
        .left {
          font-size: 18px;
          color: #555555;
          display: flex;
          align-items: center;
          .number {
            font-size: 30px;
            color: #999999;
            padding: 0 5px 0 15px;
            &.highlight {
              color: #FA6400;
            }
          }
          
        }
       
      }
      .bottom {
        display: flex;
        padding-top: 35px;
        .item {
          display: flex;
          align-items: center;
          .item-left {
            font-size: 14px;
            color: #555555;
            .date {
              font-size: 14px;
              color: #CCCCCC;
            }
          }
          .item-right {
            margin-left: 20px;
            display: flex;
            align-items: center;
            .number {
              font-size: 24px;
              color: #999999;
            }
            .highlight-vip {
              color: #FA6400;
            }
            .highlight-package {
              color: #2BC010;
            }
            .highlight-free {
              color: #32C5FF;
            }
          }
        }
        .line {
          height: 50px;
          width: 1px;
          background-color: #D8D8D8;
          margin: 0 40px;
        }
      }
    }
  }
  .list {
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 4px;
    margin-top: 20px;
    min-height: calc(100% - 335px);
    .table {
      width: 100%;
      margin-top: 23px;
      .table-header {
        height: 50px;
        background-color: #f4f5f8;
        font-size: 14px;
        color: #666666;
        line-height: 50px;
        display: flex;
        .header-item {
          display: inline-block;
          text-align: center;
          padding: 0 20px;
        }
      }
      .table-list {
        .table-tr {
          display: flex;
          align-items: center;
          border-bottom: solid 1px #d8d8d8;
          .table-th {
            padding: 15px 20px;
            text-align: center;
            .dubber-image {
              width: 40px;
              height: 40px;
              display: block;
              border-radius: 20px;
            }
            .dubber-name {
              text-align: center;
              margin-top: 5px;
            }
            .pay-button {
              background: #4e6eff;
              border-radius: 4px;
              font-size: 14px;
              color: #ffffff;
              width: 76px;
              height: 26px;
              line-height: 26px;
              margin-top: 3px;
            }
            .svg-icon {
              margin: 0 10px;
              cursor: pointer;
              &:hover {
                filter: invert(85%) sepia(80%) saturate(2500%) hue-rotate(330deg) brightness(115%) contrast(105%);
              }
            }
            .text-desc {
              cursor: pointer;
              .title {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              .info-content {
                position: relative;
                .svg-icon--bottom_arrow {
                  width: 12px;
                  height: 12px;
                  position: absolute;
                  right: -30px;
                  top: 4px;
                }
                .info {
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                  color: #999999;
                  margin-top: 10px;
                }
              }
            }
          }
        }
      }
    }
    footer { 
      margin-top: 18px;
    }
  }
}
</style>
